<template>
  <header class="header">
    <!--headerContainer开始-->
    <div class="headerContainer">
      <!--logo开始-->
      <!--<a href="javascript" class="logo">-->

        <router-link :to="{name: 'home'}" class="item logo" exact >
          <img src="~@/assets/image/logo_01.png" alt="" width="160" height="51">
        </router-link>

      <!--</a>-->
      <!--logo结束-->
      <!--导航开始-->
      <div id="nav" class="nav">
        <router-link :to="{name: 'home'}" class="item" exact style="padding: 0px 30px">首页</router-link>
        <router-link :to="{name:'dynamic'}" class="item">新闻动态</router-link>
        <router-link :to="{name: 'product'}" class="item">产品与服务</router-link>
        <router-link :to="{name: 'aboutus'}" class="item">关于我们</router-link>
        <!-- <router-link :to="{name: 'idea'}" class="item">企业理念</router-link> -->
        <!-- <router-link :to="{name: 'TeamList'}" class="item" :class="{routerLinkActive:team}">精英团队</router-link> -->
        <router-link :to="{name: 'propaganda'}" class="item">视频宣传</router-link>
        <router-link :to="{name: 'JoinUsPart'}" class="item" :class="{routerLinkactive:joinus}">加入我们</router-link>
      </div>
      <!--导航结束-->
      <!--热线电话开始-->
      <div class ="hotline clearfix">
        <img src="~@/assets/image/icon_01.png" width="38" height="38"/>
        <div class="tel">
          <div class="telText">热线电话</div>
          <div class="telnumber">15059117433</div>
        </div>
      </div>
      <!--热线电话结束-->
    </div>
    <!--headerContainer开始-->
  </header>
</template>

<script>
    export default {
        name: "Nav",
       data(){
          return {
            team:false,
            joinus:false
          }
       },
      watch: {
          "$route": {
            deep: true,
            immediate: true,
            handler(to,from) {
              var that = this;
                if(to.path =='/JobDetail'){
                    that.joinus = true;
                }else{
                     that.joinus = false;
                }
              if(to.path =='/TeamDetail'){
                that.team = true;
              }else{
                that.team = false;
              }

            }
          }
      }
    }
</script>

<style scoped lang="less">

  .header{
    width: 100%;
    height:80px;
    background:rgba(0,0,0,0.3);
    position: fixed;
    z-index: 9999999999999999999;
    .headerContainer{
      width: 1240px;
      font-size: 14px;
      margin:0 auto;
      font-weight:400;
      height: 80px;
      overflow: hidden;
      .logo{
        width: 160px;
        float: left;
        display: block;
        height: 80px;
        display: block;
        margin-right: 60px;
        img{
          margin-top: 15px;
        }
      }
      .hotline{
        margin-left:54px;
        width: 180px;
        float: left;
        display: block;
        height: 80px;
        img{
          vertical-align: middle;
          float: left;
          margin-top: 21px;
        }
        .tel{
          text-align: left;
          float: left;
          height: 80px;
          color: #fff;
          .telText{
            margin: 18px 0px 4px 0px;
          }
          .telnumber{
            font-size: 18px;
          }

        }
      }
    }
  }
  .nav {
    float: left;
    font-size: 16px;
    line-height: 80px;
    a {
      font-weight: bold;
      color:#fff;
      float: left;
      display: inline-block;
      padding: 0 28px;
      &.router-link-exact-active {
        color: #fff;
        background:linear-gradient(45deg,rgba(40,165,231,1) 0%,rgba(107,218,252,1) 100%);
      }
      &.router-link-active{
        color: #fff;
        background:linear-gradient(45deg,rgba(40,165,231,1) 0%,rgba(107,218,252,1) 100%);
      }
      &:hover{
        color: #fff;
        background-color: #34c9fb;
        text-decoration: none;
      }
    }
  }
.navbg{
    background-color: #fff!important;
}
  #nav{
    a{
      .dyj{
        color: #fff!important;
        background:linear-gradient(45deg,rgba(40,165,231,1) 0%,rgba(107,218,252,1) 100%);
      }
    }
  }
</style>
